<template>
  <div id="breadcrumb">
    <v-breadcrumbs class="pb-2" :items="items" />
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: {
      default: () => [],
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
#breadcrumb {
  padding: 0;

  .v-breadcrumbs {
    padding: 0;
  }
}
</style>
